import configs from "@/i18n/configs"
export default {
    'add-pharmaceutical-form': `${configs.addPharmaceuticalForm.en}`,
    'edit-pharmaceutical-form': `${configs.editPharmaceuticalForm.en}`,
    'the-pharmaceutical-form': `${configs.thePharmaceuticalForm.en}`
}